import { form } from '../../../formState'

import { useTexts } from './hooks/useTexts'
import { useValidatePhoneNumber } from './hooks/useValidatePhoneNumber'

export function Phone() {
  const texts = useTexts()
  const validatePhoneNumber = useValidatePhoneNumber()

  form.useAddFieldValidation('phone', async (field, _formApi) => {
    const phoneField = field.value

    if (phoneField && phoneField.status === 'exact' && phoneField.value.length > 0) {
      const phone = phoneField.value

      const phoneIsValid = await validatePhoneNumber(phone)

      if (!phoneIsValid) {
        return texts.invalidPhone
      }
    }
  })

  return (
    <form.BulkTextField
      name="phone"
      mixedLabel={texts.mixed}
      label={texts.phone}
      validateOn="blur"
    />
  )
}
